<template>
	<span>
		<slot />
	</span>
</template>

<script>
export default {
	props: {
		targetLineCount: {
			default: 1,
			type: Number,
		},
		unit: {
			default: 'px',
			type: String,
		},
		min: {
			default: 12,
			type: Number,
		},
		max: {
			default: 36,
			type: Number,
		},
	},
	data() {
		return {
			observer: null,
		};
	},
	mounted() {
		this.calculate();
		if ('MutationObserver' in window && null === this.observer) {
			// Create the observer (and what to do on changes...)
			this.observer = new MutationObserver(this.calculate);
			// Setup the observer
			this.observer.observe(this.$el, { subtree: true, characterData: true });
		}

		window.addEventListener('resize', this.calculate);
	},
	beforeDestroy: function () {
		// Clean up
		this.observer.disconnect();
		window.removeEventListener('resize', this.calculate);
	},
	methods: {
		calculate() {
			let element = this.$el;
			let fontSize = this.max;
			let stepSize = 'px' === this.unit ? 1 : 0.05;
			// first make it an inline block and set the line height to a fixed pixel value
			element.style.display = 'inline-block';
			element.style.lineHeight = '1px';
			// then keep trying untill it fits

			element.style.fontSize = fontSize + this.unit;
			while (element.offsetHeight > this.targetLineCount && fontSize > this.min) {
				fontSize -= stepSize;
				element.style.fontSize = fontSize + this.unit;
			}

			this.$emit('resize', {
				size: fontSize,
				unit: this.unit,
			});

			// found it!!
			// reset the styles
			element.style.display = null;
			element.style.lineHeight = null;
		},
	},
};
</script>
